export default function normalizeNumber(raw: string): number {
    if (!raw) return 0;

    const only = raw.replace(/[\sR$%]/gi, '').replace(/\u00A0/g, '');

    const cleaned = only.replace(/[^\d,.-]/g, '');

    if (cleaned.includes(','))
        return parseFloat(cleaned.replace(/\./g, '').replace(',', '.'));
    return parseFloat(cleaned);
}
